import React from "react";
import { labelCls, textareaCls } from "./formStyles";

// Barre de soumission commune (bouton + messages d'erreur/succès) réutilisée
// par les 5 formulaires d'étape.
export function SubmitBar({ loading, error, success }) {
  return (
    <div className="pt-1">
      <div className="flex justify-end">
        <button
          type="submit"
          disabled={loading}
          className={`px-5 py-2 rounded-xl text-sm font-semibold transition-colors ${
            loading
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-[#5C1A30] text-white hover:bg-[#4a1526]"
          }`}
        >
          {loading ? "Envoi..." : "Soumettre"}
        </button>
      </div>
      {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
      {success && (
        <p className="text-sm text-emerald-600 mt-2">Formulaire envoyé avec succès !</p>
      )}
    </div>
  );
}

// Segmented control Oui/Non (ou Fait/Pas Fait/N/A) — remplace les paires de
// <input type="radio"> d'origine, même formData key / même valeur stockée,
// juste un autre mécanisme de sélection (cf. ClotureStageModal.js
// resultatControle Conforme/Réserves).
export function ToggleGroup({ label, value, onChange, options }) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap py-1">
      <label className="text-sm font-semibold text-gray-700">{label}</label>
      <div className="flex gap-1.5">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`px-3 py-1.5 rounded-lg border text-xs font-semibold transition-colors ${
              value === opt
                ? "border-[#5C1A30] bg-[#5C1A30]/5 text-[#5C1A30]"
                : "border-gray-200 text-gray-500 hover:border-gray-300"
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export function CheckField({ label, checked, onChange }) {
  return (
    <label className="flex items-center gap-2 text-sm text-gray-700">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="w-4 h-4 rounded border-gray-300 text-[#840040] focus:ring-[#840040]/30"
      />
      {label}
    </label>
  );
}

export function CommentField({ value, onChange, rows = 4, label = "Commentaire" }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      <textarea value={value} onChange={onChange} required rows={rows} className={textareaCls} />
    </div>
  );
}

// Ligne de lecture seule pour les vues "Consulter".
export function ReadField({ label, value }) {
  return (
    <p className="text-sm leading-relaxed">
      <span className="font-semibold text-gray-500">{label} :</span>{" "}
      <span className="text-gray-800">{value || "—"}</span>
    </p>
  );
}
